import { FormControl, FormGroup } from "@angular/forms";

export enum LOG_TYPE
{
  INFO = "info",
  ERROR = "error",
  CRITICAL = "critical",
  WARNING = "warning",
}

export interface LoggerRequest
{
  errtitle: string;
  functionname: string;
  level: LOG_TYPE;
  message: string;
  module: string;
  pathName: string;
  appId: string;
  browser: string;
  browserversion: string;
  ostype: string;
  timestamp: string;
  versioncode: string;
}

export type APIResponse<T> = SuccessResponse<T> | ErrorResponse<T>;

export interface SuccessResponse<T>
{
  status: Status.Success;
  data: T;
}

export interface ErrorResponse<T>
{
  status: Status.Error;
  error: string | any;
  data: T;
}

export enum Status
{
  Success = "Success",
  Error = "Error",
  ERROR_JWT = "jwt",
  ERROR_JWT_01 = "JWT01",
  ERROR_JWT_02 = "JWT02",
  ERROR_PER = "PER01",
  ERROR_AUT2 = "AUT2",
  SIG01 = "SIG01",
  SAS13 = "SAS13"
}

export class SERVICE_URL 
{
  static readonly GET_ALL_PLAN = 'api/plan/get/all';
  static readonly GET_BUY_PLAN = 'api/payment/buy';
  static readonly GET_PROFILE = 'api/admin/profile/get';
  static readonly PAYMENT_GATEWAY = '/processpayment/entry';
  static readonly ACCOUNT_AND_BILLING = 'design/billing';
  static readonly GET_SUBSCRIPTION_DETAILS = 'api/payment/subscription/details';
  static readonly CANCEL_SUBSCRIPTION = 'api/app/subscription/cancel';
  static readonly RENEW_SUBSCRIPTION = 'api/payment/subscription/renew';
  static readonly GET_PAYMENT_ORDER_STATUS = 'api/payment/order/status';
  static readonly SAVE_PUBLIC_EMAIL = 'api/public/email';
}

export enum PAYMENT_QUERY
{
  PROVIDER_ID = 'provider_id',
  ORDER_PAYMENT_ID = 'order_payment_id',
  SESSION_ID = 'session_id',
  REDIRECT_URL = 'redirect_url',
  AUTH_TOKEN = 'auth_token',
  ORG_ID = 'org_id',
  TOKEN = 'token',
  STATUS = 'status',
  ERROR_CODE = 'error_code',
  ERROR_MESSAGE = 'error_msg',
  IS_CONTRACTOR = 'isContractor',
  NAME = 'name',
  EMAIL = 'email',
}

export type ModalIconClass = {
  [key in AlertModalStatus]: {
    class: string,
    iconName: string;
    iconClass: string;
  }
};

export enum AlertModalStatus
{
  success = "Success",
  failed = "Failed",
  confirm = 'Confirmation'
}

export enum OrderStatus
{
  New = 1,
  Waiting_For_Payment = 8,
  Payment_Failed = 9,
  Fulfillment_Success = 10,
  Fulfillment_Failed = 11,
}

export enum InvoiceStatus
{
  Paid = 1,
  Pending = 2,
  Failed = 3,
}

export enum PlanFrequencyType
{
  Monthly = 1,
  Yearly = 2,
  Daily = 3,
  Weekly = 4,
}

export enum A24SubscriptionStatus
{
  active = 1,
  canceled = 2,
  incomplete = 3,
  incomplete_expired = 4,
  past_due = 5,
  trialing = 6,
  unpaid = 7,
  unKnow = 8,
}

export interface ErrorAlertVal
{
  codeList: string[];
  valueList: string[];
}

export interface AlertModal
{
  buttonName: string | string[],
  desc: string | ErrorAlertVal,
  status: AlertModalStatus,
  title: string;
  icon?: string;
}

export type ModalClass = {
  [key in AlertModalStatus]: string
};

export class DATE_TIME_FORMAT
{
  static COMMON2_DATE_TIME_FORMAT = 'dd MMM YYYY hh:mm aa';
}

export class FILE_NAME
{
  static readonly UTIL: string = 'utils.ts';
  static readonly BILLING_SUBSCRIPTION: string = 'billing-subscription.page.ts';
}

export interface AlertModalData
{
  status: AlertModalStatus;
  desc: Desc;
  isDoubleSuccBtn?: boolean;
  buttonName: string | string[];
  title: string;
}

export interface Desc
{
  code?: string,
  value: string;
}

export type ControlsOf<T extends Record<string, any>> = {
  [K in keyof T]: T[K] extends Record<any, any>
  ? FormGroup<ControlsOf<T[K]>>
  : FormControl<T[K]>;
};

export enum PUBLIC_EMAIL_METHOD
{
  BUILD_NEW_PROJECT = 'Build a new project',
  SCALE_AN_EXISTING_PROJECT = 'Scale an existing project',
  OUTSOURCING = 'Outsourcing',
}

export enum PUBLIC_EMAIL_SERVICE
{
  DEVELOPMENT = 'Development',
  ONBOARD = 'Design',
  OTHER = 'Other',
  DEVELOPMENT_DESIGN = 'Development & Design',
}

export enum PUBLIC_EMAIL_TYPE
{
  ENTERPRISE = 'WOV - Enterprise',
  ONBOARD = 'WOV - Onboard',
}

export class APP_ROUTES
{
  static readonly PAYMENT = '';
}

export enum TOKEN
{
  SHOPIFY_PROVIDER_TOKEN = 'spt',
  AUTH_TOKEN = 't',
  API_URL = 'u'
}

export class ROUTER_PARAM
{
  static readonly PARAM = 'param';
}
